<template>
<kt-panel>
    <div class="accordion accordion-toggle-arrow" id="depositRequestsFilter">
        <div class="card" style="overflow:inherit">
            <div class="card-header bg-transparent" id="headingOne">
                <div class="card-title collapsed" data-toggle="collapse" 
                    data-target="#filterForm"
                    aria-controls="filterForm">
                    {{ $t('label.search') }}
                </div>
            </div>
            <div id="filterForm" class="collapse" aria-labelledby="filterForm" data-parent="#depositRequestsFilter">
                <div class="card-body">
                    <form @submit.prevent="action($event, query)">
                        <kt-form-section>
                            <kt-form-row>
                                <kt-col xs="12" sm="6" md="4">
                                    <kt-form-group>
                                        <kt-form-label for="gateway_title">
                                            {{ $t('label.gateway_title') }}
                                        </kt-form-label>
                                        <kt-form-control
                                                ref="gateway_title"
                                                dir="rtl"
                                                name="gateway_title"
                                                id="gateway_title"
                                                v-model="query.gateway_title"
                                        />
                                    </kt-form-group>
                                </kt-col>
                                <kt-col xs="12" sm="6" md="4">
                                    <kt-form-group>
                                        <kt-form-label for="deposit_id">
                                            {{ $t('deposit.deposit_id') }}
                                        </kt-form-label>
                                        <kt-form-control
                                                ref="factor_number"
                                                dir="ltr"
                                                name="factor_number"
                                                id="factor_number"
                                                v-model="query.factor_number"
                                        />
                                    </kt-form-group>
                                </kt-col>
                            </kt-form-row>
                        </kt-form-section>
                        <kt-form-section>
                            <input type="submit" class="btn btn-success btn-wide" :value="$t('label.filter')">
                        </kt-form-section>
                    </form>
                </div>
            </div>
        </div>
    </div>
</kt-panel>
</template>

<script>
import { requestStatus,requestStatusStr } from '@/constants/deposit'
import {i18n} from "@/plugins/i18n";
import $ from "jquery";

export default {
    props: {
        action: {
            default: function(e, query) {},
            required: true,
        }
    },
    mounted() {
        this.afterDispatch()
    },
    methods: {
        afterDispatch() {
            $('.kt-selectpicker').selectpicker({
                size: 4,
                liveSearch: true,
                noneResultsText: i18n.t('selectpicker.none_result'),
                selectAllText: i18n.t('selectpicker.select_all'),
                noneSelectedText: i18n.t('selectpicker.nothing_selected')
            })
        },
    },
    data() {
        return {
            query: {
            },
            requestStatus,
            requestStatusStr,
        }
    }
}
</script>

<style>

</style>